export const APP_VERSION = "1.0.0";

export const PRIVACY_POLICY_URL = "/privacy-policy.html";
export const COOKIE_POLICY_URL = "/cookie-policy.html";
export const COPYRIGHT_STRING = "Copyright OSA Community by Osa srl – Via Cavour 15 – 21013 Gallarate (VA)";
export const COPYRIGHT_STRING_2 = "Reg. delle imprese di Varese n° Rea: 378020 – Capitale sociale: 20.000 €";
export const VAT = "06888540967";
export const HELP_EMAIL = "supporto@osacommunity.it";
export const OSA_COMMUNITY_WEBSITE = "https://osacommunity.it/";
export const OSA_UPSELL_LINK = `mailto:${HELP_EMAIL}`;
export const TEST_PUBLIC_PROFILE = "/#/p/mirco.giorgio.gasparotto";

export const THREAD_LEADERBOARDS_CAROUSEL_TIMING = 5000;

export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || "https://api-portale.osacommunity.com/api";
export const BASE_STORAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL || "https://storage.googleapis.com/osa-prod-assets/";
export const TUTORIAL_VIMEO_ID = "459320179"
export const MOBILE_MEDIA_QUERY_THRESHOLD = 768;

export const SERVER_DATE_FORMAT = "DD/MM/yyyy";

export const STRIPE_CLIENT_KEY = process.env.REACT_APP_STRIPE_PK || "pk_live_51H9XRnJsdX69xrX1Om5fRzH9PuIoETTpnzbAfT4a4QW5a7RSciA3xTFglJnuhQUl7G1fsb5kYB81pSsUEmTthav200mvpWIIah";
export const SHOW_MESSENGER_FAB = false;

export const VIDEO_PROGRESS_INTERVAL_MS = 10 * 1000; // 10 seconds

export const SUBSCRIPTION_TYPES = {
    CerchiaAudaci: "cerchia-audaci",
    CerchiaAudaciSuperior: "cerchia-audaci-superior",
    OsaDigital: "osa-digital",
    OsaDigitalPlus: "osa-digital-plus",
    OsaKnight: "cavaliere-osa",
    OsaKnightExclusive: "cavaliere-osa-exclusive"
};
export const SUBSCRIPTIONS_DETAIL = {
    [SUBSCRIPTION_TYPES.CerchiaAudaci]: {
        name: "Cerchia degli Audaci",
        server_id: "osa-digital",
        price: "750,00+iva",
        upsell_link: OSA_UPSELL_LINK,
        upsell_name: "Cerchia degli Audaci Superior",
        benefits: [
            "Profilo personale e profilo azienda;",
            "Accesso a contenuti selezionati esclusivi;",
            "Accesso ad alcuni eventi selezionati;",
            "Accesso ai gruppi e le chat di confronto con la community;"
        ]
    },
    [SUBSCRIPTION_TYPES.OsaDigital]: {
        name: "Cerchia degli Audaci",
        server_id: "osa-digital",
        price: "750,00+iva",
        upsell_link: OSA_UPSELL_LINK,
        upsell_name: "Cerchia degli Audaci Superior",
        benefits: [
            "Profilo personale e profilo azienda;",
            "Accesso a contenuti selezionati esclusivi;",
            "Accesso ad alcuni eventi selezionati;",
            "Accesso ai gruppi e le chat di confronto con la community;"
        ]
    },
    [SUBSCRIPTION_TYPES.CerchiaAudaciSuperior]: {
        name: "Cerchia degli Audaci Superior",
        server_id: "osa-digital-plus",
        price: "1000,00+iva",
        upsell_link: OSA_UPSELL_LINK,
        upsell_name: "Cavaliere OSA",
        benefits: [
            "1000€+iva invece di 1500€+iva anno fino al 30/09",
            "Profilo personale e profilo azienda;",
            "Accesso a contenuti selezionati esclusivi;",
            "Accesso ad alcuni eventi selezionati;",
            "Accesso ai gruppi e le chat di confronto con la community;"
        ]
    },
    [SUBSCRIPTION_TYPES.OsaDigitalPlus]: {
        name: "Cerchia degli Audaci Superior",
        server_id: "osa-digital-plus",
        price: "1000,00+iva",
        upsell_link: OSA_UPSELL_LINK,
        upsell_name: "Cavaliere OSA",
        benefits: [
            "1000€+iva invece di 1500€+iva anno fino al 30/09",
            "Profilo personale e profilo azienda;",
            "Accesso a contenuti selezionati esclusivi;",
            "Accesso ad alcuni eventi selezionati;",
            "Accesso ai gruppi e le chat di confronto con la community;"
        ]
    },
    [SUBSCRIPTION_TYPES.OsaKnight]: {
        name: "Cavaliere OSA",
        price: "5000,00",
        upsell_link: OSA_UPSELL_LINK,
        upsell_name: "Cavaliere OSA Exclusive",
        benefits: [
            "Profilo personale e profilo azienda;",
            "Accesso a tutti i contenuti;",
            "Accesso agli eventi;",
            "Accesso ai gruppi e le chat di confronto con la community;"
        ]
    },
    [SUBSCRIPTION_TYPES.OsaKnightExclusive]: {
        name: "Cavaliere OSA Exclusive",
        price: "5000,00",
        upsell_link: OSA_COMMUNITY_WEBSITE,
        benefits: [
            "Profilo personale e profilo azienda;",
            "Accesso a tutti i contenuti;",
            "Accesso agli eventi;",
            "Accesso ai gruppi e le chat di confronto con la community;"
        ]
    }
}

export const ALLOWED_SUBSCRIPTION_TYPES_ON_SIGNUP = [SUBSCRIPTION_TYPES.CerchiaAudaci, SUBSCRIPTION_TYPES.CerchiaAudaciSuperior];

export const PROVINCES = [{"key":"AG", "value":"Agrigento", "region":"Sicilia"}, {"key":"AL", "value":"Alessandria", "region":"Piemonte"}, {"key":"AN", "value":"Ancona", "region":"Marche"}, {"key":"AO", "value":"Aosta", "region":"Valle d'Aosta"}, {"key":"AQ", "value":"L'Aquila", "region":"Abruzzo"}, {"key":"AR", "value":"Arezzo", "region":"Toscana"}, {"key":"AP", "value":"Ascoli-Piceno", "region":"Marche"}, {"key":"AT", "value":"Asti", "region":"Piemonte"}, {"key":"AV", "value":"Avellino", "region":"Campania"}, {"key":"BA", "value":"Bari", "region":"Puglia"}, {"key":"BT", "value":"Barletta-Andria-Trani", "region":"Puglia"}, {"key":"BL", "value":"Belluno", "region":"Veneto"}, {"key":"BN", "value":"Benevento", "region":"Campania"}, {"key":"BG", "value":"Bergamo", "region":"Lombardia"}, {"key":"BI", "value":"Biella", "region":"Piemonte"}, {"key":"BO", "value":"Bologna", "region":"Emilia Romagna"}, {"key":"BZ", "value":"Bolzano", "region":"Trentino Alto Adige"}, {"key":"BS", "value":"Brescia", "region":"Lombardia"}, {"key":"BR", "value":"Brindisi", "region":"Puglia"}, {"key":"CA", "value":"Cagliari", "region":"Sardegna"}, {"key":"CL", "value":"Caltanissetta", "region":"Sicilia"}, {"key":"CB", "value":"Campobasso", "region":"Molise"}, {"key":"CI", "value":"Carbonia Iglesias", "region":"Sardegna"}, {"key":"CE", "value":"Caserta", "region":"Campania"}, {"key":"CT", "value":"Catania", "region":"Sicilia"}, {"key":"CZ", "value":"Catanzaro", "region":"Calabria"}, {"key":"CH", "value":"Chieti", "region":"Abruzzo"}, {"key":"CO", "value":"Como", "region":"Lombardia"}, {"key":"CS", "value":"Cosenza", "region":"Calabria"}, {"key":"CR", "value":"Cremona", "region":"Lombardia"}, {"key":"KR", "value":"Crotone", "region":"Calabria"}, {"key":"CN", "value":"Cuneo", "region":"Piemonte"}, {"key":"EN", "value":"Enna", "region":"Sicilia"}, {"key":"FM", "value":"Fermo", "region":"Marche"}, {"key":"FE", "value":"Ferrara", "region":"Emilia Romagna"}, {"key":"FI", "value":"Firenze", "region":"Toscana"}, {"key":"FG", "value":"Foggia", "region":"Puglia"}, {"key":"FC", "value":"Forli-Cesena", "region":"Emilia Romagna"}, {"key":"FR", "value":"Frosinone", "region":"Lazio"}, {"key":"GE", "value":"Genova", "region":"Liguria"}, {"key":"GO", "value":"Gorizia", "region":"Friuli Venezia Giulia"}, {"key":"GR", "value":"Grosseto", "region":"Toscana"}, {"key":"IM", "value":"Imperia", "region":"Liguria"}, {"key":"IS", "value":"Isernia", "region":"Molise"}, {"key":"SP", "value":"La-Spezia", "region":"Liguria"}, {"key":"LT", "value":"Latina", "region":"Lazio"}, {"key":"LE", "value":"Lecce", "region":"Puglia"}, {"key":"LC", "value":"Lecco", "region":"Lombardia"}, {"key":"LI", "value":"Livorno", "region":"Toscana"}, {"key":"LO", "value":"Lodi", "region":"Lombardia"}, {"key":"LU", "value":"Lucca", "region":"Toscana"}, {"key":"MC", "value":"Macerata", "region":"Marche"}, {"key":"MN", "value":"Mantova", "region":"Lombardia"}, {"key":"MS", "value":"Massa-Carrara", "region":"Toscana"}, {"key":"MT", "value":"Matera", "region":"Basilicata"}, {"key":"VS", "value":"Medio Campidano", "region":"Sardegna"}, {"key":"ME", "value":"Messina", "region":"Sicilia"}, {"key":"MI", "value":"Milano", "region":"Lombardia"}, {"key":"MO", "value":"Modena", "region":"Emilia Romagna"}, {"key":"MB", "value":"Monza-Brianza", "region":"Lombardia"}, {"key":"NA", "value":"Napoli", "region":"Campania"}, {"key":"NO", "value":"Novara", "region":"Piemonte"}, {"key":"NU", "value":"Nuoro", "region":"Sardegna"}, {"key":"OG", "value":"Ogliastra", "region":"Sardegna"}, {"key":"OT", "value":"Olbia Tempio", "region":"Sardegna"}, {"key":"OR", "value":"Oristano", "region":"Sardegna"}, {"key":"PD", "value":"Padova", "region":"Veneto"}, {"key":"PA", "value":"Palermo", "region":"Sicilia"}, {"key":"PR", "value":"Parma", "region":"Emilia Romagna"}, {"key":"PV", "value":"Pavia", "region":"Lombardia"}, {"key":"PG", "value":"Perugia", "region":"Umbria"}, {"key":"PU", "value":"Pesaro-Urbino", "region":"Marche"}, {"key":"PE", "value":"Pescara", "region":"Abruzzo"}, {"key":"PC", "value":"Piacenza", "region":"Emilia Romagna"}, {"key":"PI", "value":"Pisa", "region":"Toscana"}, {"key":"PT", "value":"Pistoia", "region":"Toscana"}, {"key":"PN", "value":"Pordenone", "region":"Friuli Venezia Giulia"}, {"key":"PZ", "value":"Potenza", "region":"Basilicata"}, {"key":"PO", "value":"Prato", "region":"Toscana"}, {"key":"RG", "value":"Ragusa", "region":"Sicilia"}, {"key":"RA", "value":"Ravenna", "region":"Emilia Romagna"}, {"key":"RC", "value":"Reggio-Calabria", "region":"Calabria"}, {"key":"RE", "value":"Reggio-Emilia", "region":"Emilia Romagna"}, {"key":"RI", "value":"Rieti", "region":"Lazio"}, {"key":"RN", "value":"Rimini", "region":"Emilia Romagna"}, {"key":"RM", "value":"Roma", "region":"Lazio"}, {"key":"RO", "value":"Rovigo", "region":"Veneto"}, {"key":"SA", "value":"Salerno", "region":"Campania"}, {"key":"SS", "value":"Sassari", "region":"Sardegna"}, {"key":"SV", "value":"Savona", "region":"Liguria"}, {"key":"SI", "value":"Siena", "region":"Toscana"}, {"key":"SR", "value":"Siracusa", "region":"Sicilia"}, {"key":"SO", "value":"Sondrio", "region":"Lombardia"}, {"key":"TA", "value":"Taranto", "region":"Puglia"}, {"key":"TE", "value":"Teramo", "region":"Abruzzo"}, {"key":"TR", "value":"Terni", "region":"Umbria"}, {"key":"TO", "value":"Torino", "region":"Piemonte"}, {"key":"TP", "value":"Trapani", "region":"Sicilia"}, {"key":"TN", "value":"Trento", "region":"Trentino Alto Adige"}, {"key":"TV", "value":"Treviso", "region":"Veneto"}, {"key":"TS", "value":"Trieste", "region":"Friuli Venezia Giulia"}, {"key":"UD", "value":"Udine", "region":"Friuli Venezia Giulia"}, {"key":"VA", "value":"Varese", "region":"Lombardia"}, {"key":"VE", "value":"Venezia", "region":"Veneto"}, {"key":"VB", "value":"Verbania", "region":"Piemonte"}, {"key":"VC", "value":"Vercelli", "region":"Piemonte"}, {"key":"VR", "value":"Verona", "region":"Veneto"}, {"key":"VV", "value":"Vibo-Valentia", "region":"Calabria"}, {"key":"VI", "value":"Vicenza", "region":"Veneto"}, {"key":"VT", "value":"Viterbo", "region":"Lazio"}];
export const GENDERS = [
    {key: "male", value: "common.gender.male"},
    {key: "female", value: "common.gender.female"},
    {key: "non-binary", value: "common.gender.non-binary"},
    {key: "other", value: "common.gender.other"},
    {key: "no-response", value: "common.gender.no-response"}
]
export const VIDEO_TYPES = [
    {key: "", value: "common.all.male"},
    //{key: "normal", value: "common.video-type.normal"},
    {key: "cta", value: "common.video-type.cta"},
    {key: "training", value: "common.video-type.training"},
]

const otherLanguages = ["afrikaans",
    "albanese",
    "amarico",
    "arabo",
    "armeno",
    "azerbaigiano",
    "bengali",
    "bielorusso",
    "bislama",
    "bulgaro",
    "burmese",
    "catalano",
    "ceco",
    "chamorro",
    "chewa",
    "cinese",
    "coreano",
    "creolo",
    "croato",
    "danese",
    "dhivehi",
    "dzong-ka",
    "ebraico",
    "estone",
    "farsi",
    "figiano",
    "filippino",
    "finlandese",
    "francese",
    "georgiano",
    "ghanese",
    "giapponese",
    "greco",
    "hindi",
    "indonesiano",
    "inglese",
    "inuit (eschimese)",
    "irlandese",
    "islandese",
    "kazako",
    "khmer",
    "kinyaruanda",
    "kyrghiso",
    "laotiano",
    "latino",
    "lettone",
    "lituano",
    "lussemburghese",
    "macedoniano",
    "malese",
    "malgascio",
    "maltese",
    "mongoliano",
    "nauruan",
    "nepali",
    "norvegese",
    "olandese",
    "palauano",
    "persiano",
    "pidgin",
    "polacco",
    "portoghese",
    "rapanui",
    "rumeno",
    "russo",
    "samoano",
    "serbo-croato",
    "singalese",
    "slovacco",
    "sloveno",
    "spagnolo",
    "svedese",
    "swahili",
    "swazi",
    "tagiko",
    "taiwanese",
    "thai",
    "tigregna",
    "tongano",
    "turco",
    "turkmeno",
    "tuvaluano",
    "ucraino",
    "ungherese",
    "urdu",
    "uzbeco",
    "vietnamita"]
export const LANGUAGES = [
    {key: "ita", value: "Italiano"},
    {key: "eng", value: "Inglese"},
    {key: "ted", value: "Tedesco"},
    ...otherLanguages.map(i => ({key: i, value: i}))
]
export const COMPANY_ROLES = [
    {key: "collab", value: "Collaboratore", assignable: true},
    {key: "socio", value: "Socio", assignable: true},
    {key: "OWNER", value: "Amministratore", assignable: false}
]
export const COMPANY_ROLES_OBJECT = COMPANY_ROLES.reduce((a, b) => { a[b.key] = b.value; return a; }, {});
export const EMPLOYEES = [
    {key: "0", value: "1-10"},
    {key: "1", value: "11-25"},
    {key: "2", value: "26-50"},
    {key: "3", value: "51-100"},
    {key: "4", value: "100+"}
]

const allSectors = [
    "Accessori e moda","Affari internazionali","Agricoltura","Alberghiero","Alimenti e bevande","Allevamento","Amministrazione governativa","Animazione","Architettura e progettazione","Arredamento","Arti dello spettacolo","Arti e mestieri","Assicurazioni","Automazione industriale","Aviazione e aerospazio","Belle arti","Beni di consumo","Beni di lusso e gioielli","Beni primari","Biblioteche","Biotecnologie","Cantieri navali","Capitali di rischio e private equity","Carpenteria", "Carta e prodotti forestali","Centri di ricerca","Chimica","Cinematografia e film","Commercio al dettaglio","Commercio internazionale e sviluppo","Consulenza manageriale","Contabilità","Corriere e Spedizioni","Cosmetica","Design","Difesa e spazio","E-learning","Edilizia","Editoria","Elettronica di consumo","Energia rinnovabile e ambiente","Ferroviario","Filantropia","Formazione professionale","Forniture aziendali","Forze dell'ordine","Fotografia","Gestione in ambito formativo","Gestione investimenti","Gestione organizzazioni senza scopo di lucro","Gioco d'azzardo e casinò","Giudiziario","Grande distribuzione","Hardware","Imballaggi e contenitori","Immobili commerciali","Immobiliare","Import Export","Industria farmaceutica","Informatica e servizi","Ingegneria civile","Ingegneria meccanica o industriale","Internet","Intrattenimento","Investment Banking","Istituzioni religiose","Istruzione primaria e secondaria","Istruzione superiore","Lattiero caseario","Linee aeree / aviazione","Logistica","Macchinari industriali","Magazzinaggio","Marittimo","Marketing e pubblicità","Materiali edili","Media online","Media radiotelevisivi","Medicina","Medicina alternativa","Mercati dei capitali","Militare","Minerario e metalli","Musei e istituzioni","Musica","Nanotecnologie","Organizzazione politica","Organizzazioni civiche e sociali","Outsourcing / Offshoring","Petrolio ed energia","Plastica","Politiche pubbliche","Prodotti per lo sport","Produzione di alimenti","Produzione di media","Produzione elettrica e elettronica","Progettazione grafica","Pubblica sicurezza","Pubbliche relazioni e comunicazioni","Quotidiani","Raccolta fondi","Redazione e revisione","Relazioni (governo)","Reti informatiche","Ricerca","Ricerche di mercato","Risorse umane","Ristorazione","Salute, benessere e fitness","Selezione e ricerca di personale","Semiconduttori","Servizi ambientali","Servizi di salute mentale","Servizi finanziari","Servizi informativi","Servizi infrastrutturali","Servizi legali","Servizi per eventi","Servizi per la persona e la famiglia","Servizi pubblici","Settore automobilistico","Settore bancario","Settore pesca","Sicurezza e investigazioni","Sicurezza informatica e delle reti","Software","Sport","Stampa","Strumenti medicali","Strutture e servizi per le attività ricreative","Strutture ospedaliere e sanità","Studio legale","Sviluppo di programmi","Tabacco","Telecomunicazioni","Tempo libero, viaggi e turismo","Tessile","Traduzione e localizzazione","Trasporti su strada / ferrovia","Ufficio esecutivo","Ufficio legislativo","Vendite all'ingrosso","Veterinaria","Vetro, ceramica e cemento","Videogiochi","Vino e liquori"
]

export const REFERENCE_SECTORS = [
    ...allSectors.map(i => ({key: i, value: i}))
]

export const ADMIN_ROLE_KEY = "OWNER";

export const HOURS_TO_CONSIDER_NEW = 24 * 2;

export const COMPANY_ADDRESS_TYPES = [
    {key: "legal", value: "Sede legale"},
    {key: "operative", value: "Sede operativa"}
]

export const VIDEOS_ORDER_BY = [
    {key: "created_at|desc", value: "Data pubblicazione"}
];
export const EVENTS_ORDER_BY = [
    {key: "created_at|desc", value: "Data pubblicazione"},
    {key: "start_at|asc", value: "Data evento"}
];
export const THREADS_ORDER_BY = [
    {key: "created_at|desc", value: "Data pubblicazione"}
];
export const PEOPLE_ORDER_BY = [
    {key: "created_at|desc", value: "Data pubblicazione"}
];

export const THREAD_TYPES = {
    thread: "discussion",
    request: "request"
};
export const THREAD_ACL_TYPES = {
    everyone: "all",
    selective: "selection",
    founders: "special"
}

export const COMMENTS_ORDER_BY = [
    {key: "chronological", value: "Cronologico"},
    {key: "upvotes", value: "Classifica"}
];
export const ACHIEVEMENT_LEVELS = {
    active: "active",
    pro: "pro",
    expert: "expert"
}
